/**
 * @generated SignedSource<<bbc06fd8ff61997ceaf6b8405d6e3425>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v5 /*: any*/)
        ],
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTimeOfDay",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTimeOfDay",
        "storageKey": null
    }, v9 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "MINUTE"
        }
    ], v10 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        }
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleTemplatePeriodDayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": (v2 /*: any*/),
                            "kind": "FragmentSpread",
                            "name": "ScheduleTemplatePeriodDay_day"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleTemplatePeriodDayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dayInPeriod",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "weekday",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplatePeriod",
                                    "kind": "LinkedField",
                                    "name": "period",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "scheduleTemplateId",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentType",
                                    "kind": "LinkedField",
                                    "name": "groupedShifts",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentTypeGroupingKey",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplateShiftGroup",
                                            "kind": "LinkedField",
                                            "name": "shiftsGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleTemplateShiftGroupGroupingKey",
                                                    "kind": "LinkedField",
                                                    "name": "group",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v9 /*: any*/),
                                                            "concreteType": "TimeSpanUnitValue",
                                                            "kind": "LinkedField",
                                                            "name": "duration",
                                                            "plural": false,
                                                            "selections": (v10 /*: any*/),
                                                            "storageKey": "duration(unit:\"MINUTE\")"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v11 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleTemplateShift",
                                                    "kind": "LinkedField",
                                                    "name": "shifts",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "unit",
                                                                    "value": "HOUR"
                                                                }
                                                            ],
                                                            "concreteType": "TimeSpanUnitValue",
                                                            "kind": "LinkedField",
                                                            "name": "duration",
                                                            "plural": false,
                                                            "selections": (v10 /*: any*/),
                                                            "storageKey": "duration(unit:\"HOUR\")"
                                                        },
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTemplateShiftBreak",
                                                            "kind": "LinkedField",
                                                            "name": "breaks",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": (v9 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "offsetEnd",
                                                                    "plural": false,
                                                                    "selections": (v10 /*: any*/),
                                                                    "storageKey": "offsetEnd(unit:\"MINUTE\")"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v9 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "offsetStart",
                                                                    "plural": false,
                                                                    "selections": (v10 /*: any*/),
                                                                    "storageKey": "offsetStart(unit:\"MINUTE\")"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "type",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "assignedEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Asset",
                                                                            "kind": "LinkedField",
                                                                            "name": "asset",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v11 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/)
                                                                    ],
                                                                    "type": "SchedulableAsset",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "User",
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v15 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SchedulableUser",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftAssetValidation",
                                                            "kind": "LinkedField",
                                                            "name": "assetValidations",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "SchedulableAsset",
                                                                    "kind": "LinkedField",
                                                                    "name": "schedulableAsset",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Asset",
                                                                            "kind": "LinkedField",
                                                                            "name": "asset",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "assetNumber",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "validateProficiency",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "SchedulableUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "schedulableUser",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "User",
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v15 /*: any*/),
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssignmentType",
                                                                    "kind": "LinkedField",
                                                                    "name": "userAssignmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssetProficiencyValidation",
                                                                    "kind": "LinkedField",
                                                                    "name": "assetProficiency",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isValid",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "ScheduleTemplatePeriodDay",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d965e17c2889328f54547b3aab6404d1",
            "id": null,
            "metadata": {},
            "name": "ScheduleTemplatePeriodDayQuery",
            "operationKind": "query",
            "text": "query ScheduleTemplatePeriodDayQuery(\n  $filter: ScheduleTemplateShiftFilterRequestInput\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ScheduleTemplatePeriodDay_day_Vt7Yj\n    id\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleTemplatePeriodDay_day_Vt7Yj on ScheduleTemplatePeriodDay {\n  id\n  dayInPeriod\n  weekday\n  period {\n    id\n    scheduleTemplateId\n  }\n  groupedShifts(filter: $filter) {\n    group {\n      assignmentType {\n        id\n        title\n      }\n    }\n    shiftsGroups {\n      group {\n        startTimeOfDay\n        endTimeOfDay\n        duration(unit: MINUTE) {\n          value\n        }\n        event {\n          id\n          name\n        }\n      }\n      shifts {\n        id\n        duration(unit: HOUR) {\n          value\n        }\n        assignmentType {\n          id\n          title\n        }\n        breaks {\n          offsetEnd(unit: MINUTE) {\n            value\n          }\n          offsetStart(unit: MINUTE) {\n            value\n          }\n          type\n        }\n        endTimeOfDay\n        startTimeOfDay\n        ...ScheduleTemplateShift_shift\n      }\n      ...ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift\n    }\n  }\n}\n\nfragment ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift on ScheduleTemplateShiftGroup {\n  shifts {\n    assetValidations {\n      schedulableAsset {\n        asset {\n          id\n          name\n          assetNumber\n          validateProficiency\n        }\n        id\n      }\n      schedulableUser {\n        user {\n          fullName\n          id\n        }\n        id\n      }\n      userAssignmentType {\n        title\n        id\n      }\n      assetProficiency {\n        isValid\n      }\n    }\n    id\n  }\n}\n\nfragment ScheduleTemplateShift_shift on ScheduleTemplateShift {\n  id\n  assignedEntity {\n    __typename\n    ...SchedulableAsset_entity\n    ...SchedulableUser_entity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    id\n    title\n  }\n}\n"
        }
    };
})();
node.hash = "9baba52094eac94ddae7ae9e05cd968a";
export default node;
